/* global axios */
import ApiClient from './ApiClient';

// Self-service billing portal for a blocked account. Works WHILE the account is blocked
// (the backend bypasses the 402 gate for this endpoint).
class BillingPortalAPI extends ApiClient {
  constructor() {
    super('billing_portal', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  refresh() {
    return axios.post(`${this.url}/refresh`);
  }
}

export default new BillingPortalAPI();
